import { render, staticRenderFns } from "./BaseTemplateSuccess.vue?vue&type=template&id=c405c72e&scoped=true&"
import script from "./BaseTemplateSuccess.vue?vue&type=script&lang=js&"
export * from "./BaseTemplateSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BaseTemplateSuccess.vue?vue&type=style&index=0&id=c405c72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c405c72e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VImg})
